
    import {
        defineComponent,
    } from 'vue';
    import DatesTabs from '@ve/components/hotel/datesTabs/desktop/DatesTabs.vue';
    import OperatorsFilterHotel from '@ve/components/filters/operatorsFilter/desktop/OperatorsFilterHotel.vue';
    // import ProductTypeFilter from '@ve/components/filters/productTypeFilter/desktop/ProductTypeFilter.vue';
    import MealsFilterHotel from '@ve/components/filters/mealsFilter/desktop/MealsFilterHotel.vue';
    import AdditionalFiltersHotel from './AdditionalFiltersHotel.vue';

    import useHotelPageFilters from '../common/useHotelPageFilters';

    export default defineComponent({
        name: 'hotel-page-filters',
        components: {
            DatesTabs,
            // ProductTypeFilter,
            OperatorsFilterHotel,
            MealsFilterHotel,
            AdditionalFiltersHotel,
        },
        setup(propx, ctx) {
            return useHotelPageFilters(ctx);
        },
    });
